import type { TFnType } from "@tolgee/react";
import { IBuildType, IShow } from "@evennt-tech/api-v2-core";
import { showLocalMapKey } from "tools/show/localMap/localization/localizeShow";

/** A count every language puts in its "all of them" form: `many` in Ukrainian, `other` in English or German. */
const MANY = 5;

/**
 * "Back to all …" with the show term in its plural (FS-3341). Only a Local Map
 * option written as an ICU plural has one. A plain term keeps the old sentence,
 * whose English builds the plural itself ("{show}s").
 */
export const backToAllLabel = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "showLocalMap"> | undefined,
  t: TFnType
): string => {
  const key = showLocalMapKey(show, buildType);
  const one = t(key, { count: 1 });
  const many = t(key, { count: MANY });

  return many === one
    ? t("common.nav.back_to_all", { show: one })
    : t({
        key: "common.nav.back_to_all_plural",
        defaultValue: "Back to all {shows}",
        params: { shows: many },
      });
};
